import Vue from "vue";
import VueRouter from "vue-router";
import SignIn from "../user/pages/UserSignIn.vue";
import InvoiceDownload from "../accounts/pages/InvoiceDownload.vue";
import i18n from "../i18n.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "SignIn",
    component: SignIn,
    meta: { display: false, redirectAuthUser: true },
  },
  {
    path: "/dashboardold",
    name: "DashboardOld",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../user/pages/Dashboard.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../user/pages/DashboardNew.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/invoice-download/:id",
    name: "InvoiceDownload",
    component: InvoiceDownload,
    meta: { display: false },
  },
  {
    path: "/menuitems",
    name: "MenuItems",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../menu-packages/pages/MenuItems.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/meal-details",
    name: "MealDetails",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../menu-packages/pages/MealDetails.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/inactive-customers",
    name: "InActiveCustomers",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../customer/pages/InActiveCustomers.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/menucategory",
    name: "MenuCategory",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../menu-packages/pages/MenuCategory.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/category-types",
    name: "CategoryTypes",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../menu-packages/pages/MenuCategoryTypes.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/plans",
    name: "Packages",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../menu-packages/pages/Packages.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/managers",
    name: "ManagersMain",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../managers/pages/ManagersMain.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/notifications",
    name: "NotificationMain",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../notifications/pages/NotificationMain.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/CustomerDietitianAppt",
    name: "CustomerDietitianAppointment",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../customer/components/dietitian/CustomerDietitianAppointment.vue"),
    meta: { requiresAuth: true },
  },

  // {
  //   path: '/settings',
  //   name: 'SettingsMain',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */'../settings/pages/SettingsMain.vue'),
  //   meta: { requiresAuth: true }
  // },
  {
    path: "/faq",
    name: "Faq",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../faq/pages/FaqMain.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/contact-method",
    name: "ContactMethod",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../contact-method/pages/ContactMethod.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/api-user",
    name: "APIUsers",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../api-user/pages/APIUsers.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/customertags",
    name: "CustomerTag",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../customer/pages/CustomerTag.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/customers",
    name: "CustomerMain",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../customer/pages/CustomerMain.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/customer_details",
    name: "CustomerDetails",
    component: () => import(/* webpackChunkName: "about" */ "../customer/pages/CustomerDetails.vue"),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/customers-with-no-meals",
    name: "CustomersWithNoMeals",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../customer/pages/CustomersWithNoMeals.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/customers-birthday-report",
    name: "BirthdayReport",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../customer/pages/BirthdayReport.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/dietician_details",
    name: "DietitianDetails",
    component: () => import(/* webpackChunkName: "about" */ "../dietitian/pages/DietitianDetails.vue"),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/stock",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../stock/pages/StockMain.vue"),
    children: [
      {
        path: "stock_details",
        name: "StockDetails",
        component: () => import(/* webpackChunkName: "about" */ "../stock/pages/StockDetails.vue"),
        props: true,
        meta: { requiresAuth: true },
      },
      {
        path: "purchase",
        name: "StockPurchase",
        component: () => import(/* webpackChunkName: "about" */ "../stock/pages/StockPurchase.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "adjust_stock",
        name: "StockAdjust",
        component: () => import(/* webpackChunkName: "about" */ "../stock/pages/StockAdjust.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "master_data",
        name: "StockMaster",
        component: () => import(/* webpackChunkName: "about" */ "../stock/pages/StockMaster.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "units",
        name: "Units",
        component: () => import(/* webpackChunkName: "about" */ "../stock/pages/Units.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "brand",
        name: "Brand",
        component: () => import(/* webpackChunkName: "about" */ "../stock/brand/pages/Brand.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "vendor",
        name: "Vendor",
        component: () => import(/* webpackChunkName: "about" */ "../stock/pages/Vendor.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "monthlyUsage",
        name: "MonthlyUsage",
        component: () => import(/* webpackChunkName: "about" */ "../stock/pages/MonthlyUsage.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "monthlyPurchase",
        name: "MonthlyPurchase",
        component: () => import(/* webpackChunkName: "about" */ "../stock/pages/MonthlyPurchase.vue"),
        meta: { requiresAuth: true },
      },
    ],
    meta: { requiresAuth: true },
  },
  // {
  //   path: '/stock/master_data',
  //   name: 'StockMaster',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */'../stock/pages/StockMaster.vue'),
  //   meta: { requiresAuth: true }
  // },
  {
    path: "/orders",
    name: "OrdersMain",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../orders/pages/OrdersMain.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/rating",
    name: "Ratings",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../orders/pages/MealRatings.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/delivery",
    name: "DeliveryMain",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../delivery/pages/DeliveryMain.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/areas",
    name: "CustomerArea",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../customer/pages/CustomerArea.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/salesorder",
    name: "SalesOrder",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../orders/pages/SalesOrder.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/inactivesalesorder",
    name: "InactiveSalesOrder",
    // route level code-splittingsrc\orders\components\inactiveSalesOrderTable.vue
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../orders/pages/SalesOrder.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/inactivesalesordercount",
    name: "InactiveSalesOrderCount",
    // route level code-splittingsrc\orders\components\inactiveSalesOrderTable.vue
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../orders/pages/SalesOrder.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/salesorderdaywise",
    name: "SalesOrderDayWise",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../orders/pages/SalesOrder.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/sales-order-discount",
    name: "SalesOrderDiscount",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../orders/pages/SalesOrder.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/drivers",
    name: "Drivers",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../reports/pages/drivers.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/referrals",
    name: "Referrals",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../referral-transactions/pages/ReferralsPage"),
    meta: { requiresAuth: true },
  },
  {
    path: "/dieticians",
    name: "Dietitians",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../dietitian/pages/dietitianView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/celebrity",
    name: "Celebrity",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../celebrity/pages/CelebrityView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/celebrity_info",
    name: "CelebrityInfo",
    component: () => import(/* webpackChunkName: "about" */ "../celebrity/pages/CelebrityInfo.vue"),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/appointments",
    name: "Appointments",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../appointments/pages/AppointmentsView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/sales",
    name: "Sales",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../sales/pages/SalesMain.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/promocode-report",
    name: "PromoCodeReport",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../reports/pages/PromoCodeReport.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/shop-discount",
    name: "ShopDiscount",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../discount/pages/Discount.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/mealtags",
    name: "MealsTag",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../menu-packages/pages/MealsTag.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/report-status",
    name: "ReportStatus",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../reports/pages/ReportStatus.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/pausedmeals-report",
    name: "PausedMealsReport",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../reports/pages/PausedMealsReport.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/referral-report",
    name: "ReferralReport",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../reports/pages/ReferralReport.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/otp-details",
    name: "UserOTPDetails",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../customer/pages/UserOTPDetails.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/promocodes",
    name: "PromoCode",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../promotion/pages/PromoCode.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/driver-report",
    name: "DriverReport",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../reports/pages/DriverReport.vue"),
  },
  {
    name: "PromoCodeDetails",
    path: "/promocode_details",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../promotion/pages/PromoCodeDetails.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/shifts",
    name: "CustomerShift",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../customer/pages/CustomerShift.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/zones",
    name: "CustomerZone",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../customer/pages/CustomerZone.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/offers",
    name: "Offers",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../offer/pages/OfferView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/permission",
    name: "Permission",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../permission/pages/Permission.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/add-permission",
    name: "AddPermission",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../permission/pages/AddPermission.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/update-permission",
    name: "UpdatePermission",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../permission/pages/AddPermission.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/staff-info",
    name: "StaffInfo",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../managers/pages/ManagerInfo.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/dietplan",
    name: "DietPlan",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../menu-packages/diet-plan/pages/DietPlan.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/error-404",
    name: "Error404",
    component: () => import(/* webpackChunkName: "about" */ "../core/pages/Error404.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/end-date-reminder",
    name: "EndDateReminder",
    component: () => import(/* webpackChunkName: "about" */ "../orders/pages/EndDateReminder.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/accounts",
    name: "AccountTransactions",
    component: () => import(/* webpackChunkName: "about" */ "../accounts/pages/AccountTransactions.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/universal-pause",
    name: "UniversalPause",
    component: () => import(/* webpackChunkName: "about" */ "../universal-pause/pages/UniversalPause.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/plan-switch",
    name: "PlanSwitch",
    component: () => import(/* webpackChunkName: "about" */ "../plan-switch/pages/PlanSwitch.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/profile-settings",
    name: "ProfileSettings",
    component: () => import(/* webpackChunkName: "about" */ "../settings/pages/PreferencesForm.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/configurations-settings",
    name: "ConfigurationsSettings",
    component: () => import(/* webpackChunkName: "about" */ "../settings/pages/Configurations.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/terms-and-conditions-settings",
    name: "TermsAndConditionsSettings",
    component: () => import(/* webpackChunkName: "about" */ "../settings/pages/TermsForm.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/tutorials-settings",
    name: "TutorialsSettings",
    component: () => import(/* webpackChunkName: "about" */ "../settings/pages/TutorialForm.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/dietitian-appointment-list",
    name: "DietitianAppointmentList",
    component: () => import(/* webpackChunkName: "about" */ "../dietitianSlotBooking/pages/DietitanAppointmentList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/monthly-customer-sales",
    name: "MonthlyCustomerSalesReport",
    component: () => import(/* webpackChunkName: "about" */ "../reports/pages/MonthlyCustomerSalesReport.vue"),
  },
  {
    path: "/dietician_slot_appointment",
    name: "DietitianSlotAppointment",
    component: () => import(/* webpackChunkName: "about" */ "../dietitian/dietitian_settings/pages/DietitianSlotAppointments.vue"),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/dietician_plan_suggestion",
    name: "PlanSuggestions",
    component: () => import(/* webpackChunkName: "about" */ "../dietitian/dietitian_settings/pages/PlanSuggestions.vue"),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/dietician-appointment-report",
    name: "DietitianAppointmentReport",
    component: () => import(/* webpackChunkName: "about" */ "../dietitian/dietitian_settings/pages/DietitianAppointmentReport.vue"),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/schedule-notification",
    name: "ScheduleNotification",
    component: () => import(/* webpackChunkName: "about" */ "../schedule-notification/pages/ScheduleNotificationMain.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/online-refund",
    name: "Refund",
    component: () => import(/* webpackChunkName: "about" */ "../accounts/pages/Refund.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/add-package",
    name: "AddPackage",
    component: () => import(/* webpackChunkName: "about" */ "../menu-packages/pages/AddPackage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/update-package",
    name: "UpdatePackage",
    component: () => import(/* webpackChunkName: "about" */ "../menu-packages/pages/UpdatePackage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/gateway-charges",
    name: "GatewayCharge",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../gateway-charges/pages/GatewayCharges.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/freeze-list",
    name: "FreezeList",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../customer/components/freeze/FreezeList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/plan-transfer-report",
    name: "PlanTransferReport",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../reports/pages/PlanTransferList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/plan-switch-report",
    name: "PlanSwtichHistoryFullDetails",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../reports/pages/CustomerPlanSwitchHistory.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/plan-payment-report",
    name: "PlanPaymentHistory",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../reports/pages/PlanPaymentHistory.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/products",
    name: "ProductsListing",
    component: () => import(/* webpackChunkName: "about" */ "../ecommerse/page/Products.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/product-category",
    name: "ProductCategory",
    component: () => import(/* webpackChunkName: "about" */ "../ecommerse/page/ProductCategory.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/shopping-order",
    name: "ShoppingOrder",
    component: () => import(/* webpackChunkName: "about" */ "../ecommerse/page/Order.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/customer-shopping",
    name: "CustomerShopping",
    component: () => import(/* webpackChunkName: "about" */ "../ecommerse/page/Shopping.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/shopping",
    name: "ShoppingOrder",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../ecommerse/page/ShoppingOrder.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/customer-gender-report",
    name: "CustomerGenderWiseReport",
    component: () => import(/* webpackChunkName: "about" */ "../customer/pages/CustomerGenderWiseReport.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/customer-age-report",
    name: "CustomerAgeWiseReport",
    component: () => import(/* webpackChunkName: "about" */ "../customer/pages/CustomerAgeWiseReport.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: '/package-report',
    name: 'PackageReport',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */'../reports/pages/PackageReport.vue'),

  },
  {
    path: '/package-review',
    name: 'PackageReview',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */'../menu-packages/pages/PackageReview.vue'),
    meta: { requiresAuth: true }
  },
  {

    path: "/homepage-settings",
    name: "HomePageSettings",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../homepage-settings/pages/HomePagePackageSettings.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/article",
    name: "Article",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../article/pages/Article.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/contactUs",
    name: "contactUs",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../reports/pages/ContactUsList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/set-menu-assign",
    name: "AssignToDriver",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../set-menu/pages/AssignToDriver.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/set-menu-report-master",
    name: "SetMenuReportMaster",
    component: () => import(/* webpackChunkName: "about" */ "../set-menu/pages/SetMenuReportMasterDetails.vue"),
    props: false,
    meta: { requiresAuth: true },
  },
  {
    path: "/set-menu-order-delivery",
    name: "SetMenuOrderDelivery",
    component: () => import(/* webpackChunkName: "about" */ "../set-menu/pages/SetMenuOrderDelivery.vue"),
    props: false,
    meta: { requiresAuth: true },
  },

  {
    path: "/set-menu-customer-list",
    name: "SetMenuCustomerList",
    component: () => import(/* webpackChunkName: "about" */ "../set-menu/pages/SetMenuCustomerList.vue"),
    props: false,
    meta: { requiresAuth: true },
  },
  {
    path: "/set-menu-meals-list",
    name: "SetMenuMeals",
    component: () => import(/* webpackChunkName: "about" */ "../set-menu/pages/SetMenuMeals.vue"),
    props: false,
    meta: { requiresAuth: true },
  },
];

// path: '/settings',
// name: 'SettingsMain',
// // route level code-splitting
// // this generates a separate chunk (about.[hash].js) for this route
// // which is lazy-loaded when the route is visited.
// component: () => import(/* webpackChunkName: "about" */'../settings/pages/SettingsMain.vue'),
// meta: { requiresAuth: true }
// },
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const auth = localStorage.getItem("apollo-done-token");
  let language = to.params.lang;
  if (!language) {
    language = "en";
  }
  i18n.locale = language;

  // redirect unauth users to Signin  page
  if (to.meta.requiresAuth && !auth) {
    next({ name: "SignIn", params: { lang: i18n.locale } });
  } else if (to.meta.redirectAuthUser && auth) {
    // redirect Dashboard page for autheticated users
    next({ name: "Dashboard", params: { lang: i18n.locale } });
  } else {
    next();
  }
});

export default router;
